// Action labels for role management
export const GET_ALL_ROLES = "GET_ALL_ROLES";
export const GET_ALL_ROLES_SUCCESS = "GET_ALL_ROLES_SUCCESS";
export const GET_ALL_ROLES_FAIL = "GET_ALL_ROLES_FAIL";

export const CREATE_ROLE = "CREATE_ROLE";
export const CREATE_ROLE_SUCCESS = "CREATE_ROLE_SUCCESS";
export const CREATE_ROLE_FAIL = "CREATE_ROLE_FAIL";

export const UPDATE_ROLE = "UPDATE_ROLE";
export const UPDATE_ROLE_SUCCESS = "UPDATE_ROLE_SUCCESS";
export const UPDATE_ROLE_FAIL = "UPDATE_ROLE_FAIL";

export const SEARCH_ROLE = "SEARCH_ROLE";
export const SEARCH_ROLE_SUCCESS = "SEARCH_ROLE_SUCCESS";
export const SEARCH_ROLE_FAIL = "SEARCH_ROLE_FAIL";

export const GET_ROLE_BY_ID = "GET_ROLE_BY_ID";
export const GET_ROLE_BY_ID_SUCCESS = "GET_ROLE_BY_ID_SUCCESS";
export const GET_ROLE_BY_ID_FAIL = "GET_ROLE_BY_ID_FAIL";

// Upload all documents
export const UPLOAD_ALL_DOCUMENTS_ROLE = "UPLOAD_ALL_DOCUMENTS_ROLE";
export const UPLOAD_ALL_DOCUMENTS_ROLE_SUCCESS =
  "UPLOAD_ALL_DOCUMENTS_ROLE_SUCCESS";
export const UPLOAD_ALL_DOCUMENTS_ROLE_FAIL = "UPLOAD_ALL_DOCUMENTS_ROLE_FAIL";

export const CREATE_EDIT_ROLE_API_STATUS = "CREATE_EDIT_ROLE_API_STATUS";

export const GET_ALL_ROLES_ASC = "GET_ALL_ROLES_ASC";
export const GET_ALL_ROLES_SUCCESS_ASC = "GET_ALL_ROLES_SUCCESS_ASC";
export const GET_ALL_ROLES_FAIL_ASC = "GET_ALL_ROLES_FAIL_ASC";

// Manage Roles

// userActionTypes.js

export const FETCH_USER_DETAILS_REQUEST = "FETCH_USER_DETAILS_REQUEST";
export const FETCH_USER_DETAILS_SUCCESS = "FETCH_USER_DETAILS_SUCCESS";
export const FETCH_USER_DETAILS_FAILURE = "FETCH_USER_DETAILS_FAILURE";
export const SET_SELECTED_USER_ID = "SET_SELECTED_USER_ID";

// roleActionTypes.js

export const FETCH_ROLE_LIST_REQUEST = "FETCH_ROLE_LIST_REQUEST";
export const FETCH_ROLE_LIST_SUCCESS = "FETCH_ROLE_LIST_SUCCESS";
export const FETCH_ROLE_LIST_FAILURE = "FETCH_ROLE_LIST_FAILURE";
export const SET_SELECTED_ROLE_ID = "SET_SELECTED_ROLE_ID";

// Get roles

export const FETCH_RIGHTS_REQUEST = "FETCH_RIGHTS_REQUEST";
export const FETCH_RIGHTS_SUCCESS = "FETCH_RIGHTS_SUCCESS";
export const FETCH_RIGHTS_FAILURE = "FETCH_RIGHTS_FAILURE";

// Save Role

export const SAVE_RIGHTS_REQUEST = "SAVE_RIGHTS_REQUEST";
export const SAVE_RIGHTS_SUCCESS = "SAVE_RIGHTS_SUCCESS";
export const SAVE_RIGHTS_FAILURE = "SAVE_RIGHTS_FAILURE";

//Fetch Save Rights By Auction Center Id And User Id
export const FETCH_SAVE_RIGHTS_BY_AUCTION_CENTER_ID_AND_USER_ID =
  "FETCH_SAVE_RIGHTS_BY_AUCTION_CENTER_ID_AND_USER_ID";
export const FETCH_SAVE_RIGHTS_BY_AUCTION_CENTER_ID_AND_USER_ID_SUCCESS =
  "FETCH_SAVE_RIGHTS_BY_AUCTION_CENTER_ID_AND_USER_ID_SUCCESS";
export const FETCH_SAVE_RIGHTS_BY_AUCTION_CENTER_ID_AND_USER_ID_FAILURE =
  "FETCH_SAVE_RIGHTS_BY_AUCTION_CENTER_ID_AND_USER_ID_FAILURE";

export const CREATE_EDIT_RIGHTS_API_STATUS = "CREATE_EDIT_RIGHTS_API_STATUS";
export const GET_ROLE_API_STATUS = "GET_ROLE_API_STATUS";
export const ROLE_DISABLE = "ROLE_DISABLE";

export const ROLE_LOADER = "ROLE_LOADER";
